import axios from "axios";
import PaginationContext from "components/PaginationContext";
import { useGetPageInfos } from "hooks/page.hook";
import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

const PageVersionContext = React.createContext({
  currentPageVersion: {},
  setCurrentPageVersion: () => {},
  loading: false,
});
export default PageVersionContext;

axios.interceptors.request.use(
  (config) => {
    if (config.url === "/getPageInfos" && config.params && config.params.pathname === "/rechercher") {
      return {
        adapter: () =>
          new Promise((resolve) => {
            resolve({ data: {} });
          }),
      };
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const PageVersionContextProvider = withRouter((props) => {
  const { location, children } = props;
  const { data: page, isLoading } = useGetPageInfos(location.pathname);

  const { totalPages, setTotalPages } = useContext(PaginationContext);

  const [currentPageVersion, setCurrentPageVersion] = useState(page || {});
  const [defferedIsLoading, setDefferedIsLoading] = useState(isLoading);

  useEffect(() => {
    if (!isLoading) {
      setCurrentPageVersion(page);
      if (totalPages !== 0) {
        setTotalPages(0);
      }
    }
    setDefferedIsLoading(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, isLoading]);

  const handleChangeCurrentVersion = (pageVersion) => {
    if (pageVersion && pageVersion.id !== page.id) {
      setCurrentPageVersion(pageVersion);
      setDefferedIsLoading(isLoading);
    }
  };

  return (
    <PageVersionContext.Provider
      value={{
        currentPageVersion,
        setCurrentPageVersion: handleChangeCurrentVersion,
        loading: defferedIsLoading,
      }}
    >
      {children}
    </PageVersionContext.Provider>
  );
});
